

/**
 * 
 * Modifies the itineraries in the itineraryGroup given as arguments by filtering its elements
 * @param scoolStation 
 * @param homeStation : can be undefined (not null)
 * @param options:
 * - setsummary : true / false 
 */


export class ItineraryGroupPreprocessor{
    constructor(itineraryGroup, schoolStation, homeStation  ){
        var _itineraryGroup = itineraryGroup; 
        var _schoolStation = schoolStation;
        var _homeStation = homeStation;

        Object.defineProperty(this,'itineraryGroup',{
            get : function(){ return _itineraryGroup }
        });

        Object.defineProperty(this,'schoolStation',{
            get : function(){ return _schoolStation }
        });

        Object.defineProperty(this,'homeStation',{
            get : function(){ return _homeStation }
        });

    }
    /*=========================================== */
    /* PRIVATE                                    */
    /* ========================================== */
    setSummarizedPatternItinerary(itinerary){ return itinerary.setSummarizedPattern(this.homeStation, this.schoolStation) }

    setDirectPatternItinerary(itinerary){ return itinerary.setDirectPattern(this.homeStation, this.schoolStation) } 


    /*=========================================== */
    /* PUBLIC                                     */
    /* ========================================== */


    run(fn){
        var itineraries = this.itineraryGroup.getItineraries();
        itineraries.forEach(fn.bind(this))
    }

    preprocess(){
        this.run(this.setSummarizedPatternItinerary);
        this.run(this.setDirectPatternItinerary)
        return this.itineraryGroup;
    }


    /*=========================================== */
    /* STATIC                                     */
    /* ========================================== */
    

}

/**
var igPreprocessor = new preprocessor(itineraryGroup, homeStation, schoolStation )
igPreprocessor.run(igPreprocessor.setSummarizedPattern)
igPreprocessor.run(igPreprocessor.setDirectPattern)
 */